import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function usePandaDocSigningEnabled(requirementId: string): boolean {
  const { requirementIds } = useCbhFlag(CbhFeatureFlag.RELEASE_PANDADOC_SIGNING, {
    defaultValue: { requirementIds: [] },
  });

  if (requirementIds === "ALL") {
    return true;
  }

  return requirementIds.includes(requirementId);
}
